// @flow

import * as React from 'react'
import { Menu, Icon, Dropdown } from 'semantic-ui-react'

import type { ActiveItem } from '../app'

type El = {|
  value: string,
|}
type _Props = {
  activeItem: ActiveItem,
  disabled: boolean,
  isAdmin: boolean,
  isViewer: boolean,
  fullname: string,
  onTabClick: (SyntheticEvent<*>, El) => void,
  onChangePassword: () => void,
  onManageUsers: () => void,
  onLogout: () => void,
}
type Props = _Props & $Shape<_Props>

const MainMenu = (props: Props) => {
  let MenuItem = Menu.Item
  let DropdownItem = Dropdown.Item
  let DropdownMenu = Dropdown.Menu
  let verb = props.isAdmin ? 'Gestisci' : 'Visualizza'
  return (
    <Menu inverted fixed="top" size="huge" style={{ zIndex: '900' }}>
      <MenuItem header className="brand-title">
        CLARA
      </MenuItem>
      <MenuItem
        name="Campagne"
        active={props.activeItem === 'campaigns'}
        value="campaigns"
        onClick={props.onTabClick}
        disabled={props.disabled}
      />
      {props.isViewer === false && (
        <MenuItem
          name={`${verb} Panel`}
          active={props.activeItem === 'panels'}
          value="panels"
          onClick={props.onTabClick}
          disabled={props.disabled}
        />
      )}
      {props.isViewer === false && (
        <MenuItem
          name="Gestisci Visite"
          active={props.activeItem === 'visits'}
          value="visits"
          onClick={props.onTabClick}
          disabled={props.disabled}
        />
      )}

      <Dropdown
        item
        text="Reportistica"
        disabled={props.disabled}
        style={{ backgroundColor: props.activeItem === 'reports' ? '#3D3E3F' : '#1B1C1D' }}>
        <DropdownMenu>
          {props.isViewer === false && (
            <DropdownItem value="reports/details" onClick={props.onTabClick}>
              <Icon name="list layout" />
              <span className="text">Dettaglio visite</span>
            </DropdownItem>
          )}
          <DropdownItem value="reports/calendar" onClick={props.onTabClick}>
            <Icon name="calendar" />
            <span className="text">Calendario visite</span>
          </DropdownItem>
          <DropdownItem value="reports/chart" onClick={props.onTabClick}>
            <Icon name="area chart" />
            <span className="text">Andamento temporale</span>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>

      <Menu.Menu position="right">
        <Dropdown item text={props.fullname} disabled={props.disabled}>
          <Dropdown.Menu icon="user" style={{ float: 'right' }}>
            <DropdownItem onClick={props.onChangePassword}>
              <Icon name="key" />
              <span className="text">Cambia password</span>
            </DropdownItem>
            {props.isAdmin && (
              <DropdownItem onClick={props.onManageUsers}>
                <Icon name="settings" />
                <span className="text">Gestisci utenti</span>
              </DropdownItem>
            )}
            <DropdownItem onClick={props.onLogout}>
              <Icon name="power" />
              <span className="text">Logout</span>
            </DropdownItem>
          </Dropdown.Menu>
        </Dropdown>
      </Menu.Menu>
    </Menu>
  )
}

export default MainMenu



// WEBPACK FOOTER //
// ./src/systemwide/main-menu.js